import { render, staticRenderFns } from "./FinishInpatient.vue?vue&type=template&id=79849600"
import script from "./FinishInpatient.vue?vue&type=script&lang=js"
export * from "./FinishInpatient.vue?vue&type=script&lang=js"
import style0 from "./FinishInpatient.vue?vue&type=style&index=0&id=79849600&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports